import { jsx as t, jsxs as l } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-454 -640)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.00012207H0V20H20V0.00012207Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M8.69582 4.53621L7.78277 3.62317L7.17414 4.23192L6.56547 3.62317L5.65246 4.53621L6.26109 5.14492L5.65234 5.75363L6.56539 6.66663L7.1741 6.05796L7.78277 6.66663L8.69582 5.75363L8.08715 5.14492L8.69582 4.53621Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H10V6.66649H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 13.3334H10V19.9999H20V13.3334Z",
      fill: "#6DA544"
    })
  ]
});
export {
  r as default
};
